import React from 'react';
import Modal from '@synergycms_core/components/generic/Modal';
import styleFile from '../../../views/customerForm/CustomerForm.js';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import RichText from '@synergycms_core/components/generic/RichText';
import { compose } from "ramda";

const ConditionsModal = props => {
  const { classes } = props.theme.styles;
  return (
    <Modal
      innerStyle={['modalStyle']}
      contentStyle={classes.availModalcontent}
      closeButtonStyle={classes.closeButton}
      modalStyle={classes.hotelModalStyle}
      popover={
        <div className={classes.modalTabsList}>
          <div className={classes.headerModal}>
            <RichText
              innerStyle={classes.modalTitle}
              text={'_%política de privacidad%_'}
              translate={true}
              ucFirst={true}
            />
          </div>
          <div className={classes.titleListBlock}>
            <RichText
              innerStyle={['roboto13Black']}
              dangerouslySetInnerHTML={'_%condiciones contratacion text%_'}
              translate={true}
            />
          </div>
        </div>
      }
      typeModal={'roomDetailTooltip'}>
      <div className={classes.policiesTextToggle}>
        <RichText
          translate={true}
          ucFirst={true}
          innerStyle={['gold', classes.politicsText]}
          text={'_%política de privacidad%_'}
        />
      </div>
    </Modal>
  );
};

export default compose(withThemeJSS({ styleFile, link: true, displayName: 'ConditionsModal' }))(ConditionsModal);
